import { Poppins} from 'next/font/google'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})

export default function PaymentOptions({title,location}) {
  return (
 <>
 <section style={{backgroundColor:'#FEE9BF', padding:'20px 0px'}}>
  <div className='container'>
  <h3 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}>Flexible Payment Plans for  <span className={`ylw-clr fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}> {title} Courses </span></h3>
    <div className={`df mfdc fjsb gap20 fw fac mt32 tmt28 mmt24`}>
        <Image src={"/new-course-details/payment-option/cards.png"} width={232} height={245} alt={`Expert ${title} training center in ${location}`} loading='lazy' quality={100}/>
        <Image src={"/new-course-details/payment-option/bank.png"} width={191} height={195} alt={`Best ${title} training in ${location} for career growth`} loading='lazy' quality={100}/>
      <div className={`mtac`}>
      <p className={`fs-16 mfs-15 fwb500  ${popins.className}`}>Study Now, Pay Later</p>
       <p className={`fs-28 tfs-24 mfs-19 pdt10 fwb700 ${popins.className}`}>Questions About Payment? Call Us Now!</p>
        <button
       aria-label="Call Now for Course Enquiries" className={`fs-16 mfs-15 call-now ylw-clr mt10 fwb600 ${popins.className}`}> <Link className='ylw-clr' href={'tel:+917825888899'}>Call Now </Link></button> 
      </div>
    </div>
  </div>
 </section>
 </>
)
}
